module.exports = __webpack_public_path__ + "img/xgender.2a03d772.svg";